import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

function CookiePolicy() {
  return (
    <>
      {/* Breadcrumbs */}
      <div className="max-w-6xl mx-auto px-4">
        <Breadcrumbs />
      </div>

      {/* Hero Section */}
      <div className="bg-gray-100 py-12 mb-10">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold text-blue-700 mb-2">Cookie Policy</h1>
          <p className="text-gray-600 text-sm">
            How we use cookies to ensure secure payments, login, and smooth shopping.
          </p>
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-4xl mx-auto px-4 pb-12 text-gray-700 text-sm leading-relaxed">

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">1. What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website.
            They help websites function properly and remember important information like
            your cart, login status, and preferences.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Cookies We Use</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Essential Cookies:</strong> Required for secure login, cart
              functionality, checkout, and fraud prevention. You cannot disable these
              through our website.
            </li>
            <li>
              <strong>Performance & Analytics Cookies (Optional):</strong> Help us
              understand website usage and improve user experience. We will ask for
              consent before enabling these.
            </li>
            <li>
              <strong>Payment Cookies:</strong> Used by our secure providers including
              Stripe and PayPal during checkout.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            3. Managing Cookies
          </h2>
          <p>
            You can control or delete cookies at any time through your browser
            settings. If you disable essential cookies, some features like secure
            login and checkout may not work correctly.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            4. Updates to This Policy
          </h2>
          <p>
            We may update this policy as needed to reflect changes in technology,
            business operations, or legal requirements. Updates will be posted on
            this page with a revised date.
          </p>
        </section>

        {/* Back to Home Link */}
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center text-blue-600 hover:underline text-sm font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div data-aos="fade-up">
        <Footer />
      </div>
    </>
  );
}

export default CookiePolicy;
